'use client';

import { MapActiveFilters } from '@app/components/molecules/map-active-filters';
import { MapCloseButton } from '@app/components/molecules/map-close-button';
import { MapSearchBar } from '@app/components/molecules/map-search-bar';
import { MapWrapper } from '@app/components/molecules/map-wrapper';
import { MapFilters } from '@app/components/organisms/map-filters';
import { MapView } from '@app/components/organisms/map-view';

import { MapRootProps } from './map-root.props';

const MapRoot = ({ children }: MapRootProps) => {
    return children;
};

export const Map = {
    Root: MapRoot,
    SearchBar: MapSearchBar,
    Filters: MapFilters,
    MapView: MapView,
    MapWrapper: MapWrapper,
    CloseButton: MapCloseButton,
    ActiveFilters: MapActiveFilters,
};
